<template>
  <main class="advance-repayment">
    <div class="content-wrapper" v-if="advanceRepayQuery.data">
      <section class="info">
        <div>
          <p class="msg">截止今日待还总额(元)</p>
          <h3 class="info-momeny">
            {{ $utils.toYuan(advanceRepayQuery.data.repayAmount) }}
          </h3>
          <p class="princal">
            本金{{ $utils.toYuan(advanceRepayQuery.data.repayPrincipal) }}元 |
            利息{{ $utils.toYuan(advanceRepayQuery.data.repayInterest) }}元
          </p>
        </div>
        <div class="danger-info">
          <p>1、提前还款需一次全部还款，不支持部分还款</p>
          <p>2、借款期不足10天，利息按10天计息</p>
          <p>3、当日14点前，可申请当日的提前还款；14点后则不能申请</p>
          <p>
            4、申请提前还款，请在当日15点前保证还款账户余额充足。如果扣款失败，则提前还款失败，需次日重新申请
          </p>
        </div>
      </section>
    </div>
    <div v-else>{{ advanceRepayQuery.errorMsg }}</div>
  </main>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('loan', ['advanceRepayQuery']),
  },
}
</script>

<style lang="stylus">
@import '../../../assets/css/common-color.styl'
.advance-repayment
  .content-wrapper
    .info
      padding 2px 32px
      box-sizing border-box
      .msg
        opacity 0.8
        font-size 14px
        color gray02
        line-height 14px
      .info-momeny
        font-size 32px
        margin 8px 0 14px 0
      .princal
        opacity 0.8
        font-size 18px
        color gray02
        line-height 14px
        margin-bottom 24px
      .danger-info
        background rgba(47,134,246,0.08)
        border 1px solid rgba(47,134,246,0.10)
        border-radius 4px
        box-sizing border-box
        padding 8px
        p
          font-family PingFangSC-Regular
          font-size 12px
          color gray03
</style>
